const baseUrl = process.env.REACT_APP_BASE_URL;
const reportURL = process.env.REACT_APP_REPORT_URL;
// const baseUrl = 'http://localhost:3001/v1';
// const reportURL = 'http://localhost:3002/v1';

export const dynamicUrl = {
  login: baseUrl + '/login',
  userGoogleLogin: baseUrl + '/userGoogleLogin',
  changePassword: baseUrl + '/changePassword',
  logout: baseUrl + '/logout',
  employeeLogin: baseUrl + '/employeeLogin',
  forgotPassword: baseUrl + '/forgotPassword',
  validateForgotPasswordOtp: baseUrl + '/validateForgotPasswordOtp',
  employeeOtpValidation: baseUrl + '/employeeOtpValidation',
  reshareEmployeeLoginLink: baseUrl + '/reshareEmployeeLoginLink',
  fetchClientComponent: baseUrl + '/fetchClientComponent',
  insertCaseUrl: baseUrl + '/insertCases',
  insertVendor: baseUrl + '/insertVendor',
  fetchAllVendors: baseUrl + '/fetchAllVendors',
  updateVendor: baseUrl + '/updateVendor',
  deleteVendor: baseUrl + '/deleteVendor',
  fetchCases: baseUrl + '/fetchClientCases',
  fetchCaseByCaseStatus: baseUrl + '/fetchCaseByCaseStatus',
  fetchCaseByQcStatus: baseUrl + '/fetchCaseByQcStatus',
  fetchCaseByReportStatus: baseUrl + '/fetchCaseByReportStatus',
  getAllCaseDetails: baseUrl + '/getAllCaseDetails',
  fetchEmployeeCase: baseUrl + '/fetchEmployeeCase',
  fetchIndivCaseUrl: baseUrl + '/fetchIndividualCase',
  fetchIndivEmp: baseUrl + '/fetchIndivEmp',
  fetchConstants: baseUrl + '/fetchConstants',
  UpdateConstants: baseUrl + '/UpdateConstants',
  fetchReportDetails: baseUrl + '/fetchReportDetails',
  fetchReportDetailsCst: baseUrl + '/fetchReportDetailsCst',
  fetchQcFinalComponent: baseUrl + '/fetchQcFinalComponent',
  updateCasesUrl: baseUrl + '/updateCases',
  uploadBulkUrl: baseUrl + '/getBulkUploadUrl',
  downloadFileApi: baseUrl + '/downloadDocument',
  generateBulkUploadTemplate: baseUrl + '/generateBulkUploadTemplate',
  insertClients: baseUrl + '/insertClients',
  fetchAllClients: baseUrl + '/fetchAllClients',
  fetchAllUsers: baseUrl + '/fetchAllUsers',
  fetchIndividualUser: baseUrl + '/fetchIndividualUser',
  fetchIndividualClient: baseUrl + '/fetchIndividualClient',
  updateUser: baseUrl + '/updateUser',
  updateClient: baseUrl + '/updateClient',
  updateClientComponentNames: baseUrl + '/updateClientComponentNames',
  updateClientSpocDetails: baseUrl + '/updateClientSpocDetails',
  updateTagsForCase: baseUrl + '/updateTagsForCase',
  updateCategoriesForCase: baseUrl + '/updateCategoriesForCase',
  deleteUser: baseUrl + '/deleteUser',
  deleteClient: baseUrl + '/deleteClient',
  fetchClientByUserId: baseUrl + '/fetchClientByUserId',
  fetchUsersBySupId: baseUrl + '/fetchUsersBySupId',
  insertUsers: baseUrl + '/insertUsers',
  allocateCase: baseUrl + '/allocateCase',
  allocateMultipleCases: baseUrl + '/allocateMultipleCases',
  fetchCasesByUserId: baseUrl + '/fetchCasesByUserId',
  fetchOperationalUserComponent: baseUrl + '/fetchOperationalUserComponent',
  uploadEvidenceUrl: baseUrl + '/uploadEvidence',
  deleteEvidenceFile: baseUrl + '/deleteEvidenceFile',
  fetchCasesStatusCount: baseUrl + '/fetchCasesStatusCount',
  fetchReportStatusCount: baseUrl + '/fetchReportStatusCount',
  fetchAllocatedUsers: baseUrl + '/fetchAllocatedUsers',
  bulkUpload: baseUrl + '/bulkUpload',
  verifyCase: baseUrl + '/verifyCases',
  fetchDocumentUrl: baseUrl + '/fetchDocument',
  updateReportStatus: baseUrl + '/updateReportStatus',
  // generateReport: generateReportUrl + '/generateReport',
  generateReport: reportURL + '/generateReport',
  sendMailToClientHR: baseUrl + '/sendMailToClientHR',
  sendReminderEmail: baseUrl + '/sendReminderEmail',
  convertToSignedUrl: baseUrl + '/convertToSignedUrl',
  downloadReport: baseUrl + '/downloadReport',
  deleteCases: baseUrl + '/deleteCases',
  deleteSelectedComponents: baseUrl + '/deleteSelectedComponents',
  clearInsufficiency: baseUrl + '/clearInsufficiency',
  updateAddressVerificationType: baseUrl + '/updateAddressVerificationType',
  initiateDigitalAddressVerification: baseUrl + '/initiateDigitalAddressVerification',
  raiseInsufficiency: baseUrl + '/raiseInsufficiency ',
  raiseAdditionalCost: baseUrl + '/raiseAdditionalCost',
  reInitiateDigitalAddressVerification: baseUrl + '/reInitiateDigitalAddressVerification',
  verifyIndividualDigitalAddress: baseUrl + '/verifyIndividualDigitalAddress',
  reSendDigitalAddressVerification: baseUrl + '/reSendDigitalAddressVerification',
  fetchDigitalAddress: baseUrl + '/fetchDigitalAddress',
  submitDigitalAddressVerification: baseUrl + '/submitDigitalAddressVerification',
  updateDigitalAddressVerificationStatus: baseUrl + '/updateDigitalAddressVerificationStatus',
  generateDigitalAddressReport: reportURL + '/generateDigitalAddressReport',
  saveDigitalAddressTypes: baseUrl + '/saveDigitalAddressTypes',
  savePhysicalAddressTypes: baseUrl + '/savePhysicalAddressTypes',
  fetchInvoices: baseUrl + '/fetchInvoices',
  fetchHoldCases: baseUrl + '/fetchHoldCases',
  updateClientPricing: baseUrl + '/updateClientPricing',
  fetchClientInfoAndConfig: baseUrl + '/fetchClientInfoAndConfig',
  fetchInvoiceOverview: baseUrl + '/fetchInvoiceOverview',
  insertInvoiceOverview: baseUrl + '/insertInvoiceOverview',
  insertHoldCases: baseUrl + '/insertHoldCases',
  fetchAllInvoiceOverview: baseUrl + '/fetchAllInvoiceOverview',
  fetchIndividualInvoice: baseUrl + '/fetchIndividualInvoice',
  updateInvoiceType: baseUrl + '/updateInvoiceType',
  generateInvoiceReport: reportURL + '/generateInvoiceReport',
  updateIndividualEvidence: baseUrl + '/updateIndividualEvidence',
  updateInvoiceOverview: baseUrl + '/updateInvoiceOverview',


  generateSlaReport: reportURL + '/generateSlaReport',
  updateFile: baseUrl + '/updateFile',
  deleteHoldCase: baseUrl + '/deleteHoldCase',
  updateHoldCases: baseUrl + '/updateHoldCases',
  generateCreditNote: reportURL + '/generateCreditNote',
  getSignedUrl: baseUrl + '/getSignedUrl',
  fetchEmployeeTrackingDetails: baseUrl + '/fetchEmployeeTrackingDetails',
  fetchSingleComponentPending: baseUrl + '/fetchSingleComponentPending',
  sendGenericEmail: baseUrl + '/sendGenericEmail',
  
  componentStats: baseUrl + '/fetchComponentStats',
  componentsList: baseUrl + '/fetchComponents',
  myComponentStats: baseUrl + '/fetchMyComponentStats',
  myComponentsList: baseUrl + '/fetchMyComponents',

  uploadClientDocuments: baseUrl + '/uploadClientDocuments',
  deleteClientDocument: baseUrl + '/deleteClientDocument',
  fetchClientDocuments: baseUrl + '/fetchClientDocuments',
};

export default dynamicUrl;
